import {
    useState,
} from "react";

import {
    Box,
    Text,
    Badge,
    SimpleGrid,
    Image,
    Flex,
    Grid,
    Dialog,
} from "@chakra-ui/react";

import PdfIcon from "../../../assets/pdf.png";

import AppDrawer from "../../../components/AppDrawer";

const BASE_URL =
    process.env
        .REACT_APP_API_BASE_URL;

const ViewVehicleDrawer = ({
    vehicle,
    open,
    onClose,
}) => {
    const [
        selectedMedia,
        setSelectedMedia,
    ] = useState(
        null
    );

    if (!vehicle) {
        return null;
    }

    const vehicleImage =
        vehicle.documents?.find(
            doc =>
                doc.document_type ===
                "Vehicle Image"
        );

    const getStatusColor =
        status => {
            switch (
                status
            ) {
                case "Approved":
                    return "green";

                case "Pending":
                    return "orange";

                case "Rejected":
                    return "red";

                case "Suspended":
                    return "red";

                default:
                    return "gray";
            }
        };
  const vehicleDocuments =
    vehicle.documents?.filter(
        doc =>
            [
                "Blue Book",
                "Vehicle Image",
            ].includes(
                doc.document_type
            )
    ) || [];
    return (
        <>
            <AppDrawer
                open={open}
                onClose={
                    onClose
                }
                title="Vehicle Details"
                width="600px"
            >
                <Box>
                    <Flex
                        align="center"
                        gap={4}
                        mb={6}
                    >
                        {vehicleImage && (
                            <Image
                                src={`${BASE_URL}/${vehicleImage.file_path}`}
                                w="120px"
                                h="90px"
                                borderRadius="12px"
                                objectFit="cover"
                                cursor="pointer"
                                onClick={() =>
                                    setSelectedMedia(
                                        {
                                            src: `${BASE_URL}/${vehicleImage.file_path}`,
                                            title:
                                                "Vehicle Image",
                                            extension:
                                                vehicleImage.file_extension,
                                        }
                                    )
                                }
                            />
                        )}

                        <Box>
                            <Text
                                fontSize="24px"
                                fontWeight="700"
                            >
                                {
                                    vehicle.vehicle_make
                                }{" "}
                                {
                                    vehicle.vehicle_model
                                }
                            </Text>

                            <Text
                                color="gray.500"
                            >
                                {
                                    vehicle.registration_number
                                }
                            </Text>

                            <Badge
                                mt={2}
                                colorPalette={getStatusColor(
                                    vehicle.status
                                )}
                            >
                                {
                                    vehicle.status
                                }
                            </Badge>
                        </Box>
                    </Flex>

                    <Text
                        fontSize="11px"
                        fontWeight="600"
                        color="#64748B"
                        textTransform="uppercase"
                        mb={4}
                    >
                        Vehicle Information
                    </Text>

                    <Grid
                        templateColumns="repeat(2,1fr)"
                        gap={4}
                        mb={8}
                    >
                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Registration Number
                            </Text>

                            <Text fontWeight="600">
                                {
                                    vehicle.registration_number
                                }
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Make
                            </Text>

                            <Text fontWeight="600">
                                {
                                    vehicle.vehicle_make
                                }
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Model
                            </Text>

                            <Text fontWeight="600">
                                {
                                    vehicle.vehicle_model
                                }
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Body Type
                            </Text>

                            <Text fontWeight="600">
                                {
                                    vehicle.vehicle_body_type
                                }
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Color
                            </Text>

                            <Text fontWeight="600">
                                {
                                    vehicle.vehicle_color
                                }
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Year
                            </Text>

                            <Text fontWeight="600">
                                {new Date(
                                    vehicle.year_of_manufacturing
                                ).getFullYear()}
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Chassis Number
                            </Text>

                            <Text fontWeight="600">
                                {
                                    vehicle.chasis_number
                                }
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontSize="12px"
                                color="gray.500"
                            >
                                Engine Number
                            </Text>

                            <Text fontWeight="600">
                                {
                                    vehicle.engine_number
                                }
                            </Text>
                        </Box>
                    </Grid>

                    {!!vehicleDocuments.length && (
                        <>
                            <Text
                                fontSize="11px"
                                fontWeight="600"
                                color="#64748B"
                                textTransform="uppercase"
                                mb={3}
                            >
                                Documents
                            </Text>

                            <SimpleGrid
                                columns={2}
                                gap={3}
                            >
                                {vehicleDocuments.map(
                                    doc => {
                                        const isImage =
                                            [
                                                "png",
                                                "jpg",
                                                "jpeg",
                                                "webp",
                                            ].includes(
                                                doc.file_extension?.toLowerCase()
                                            );

                                        return (
                                            <Box
                                                key={
                                                    doc.document_id
                                                }
                                                border="1px solid"
                                                borderColor="#E2E8F0"
                                                borderRadius="10px"
                                                overflow="hidden"
                                                cursor="pointer"
                                                onClick={() =>
                                                    setSelectedMedia(
                                                        {
                                                            src: `${BASE_URL}/${doc.file_path}`,
                                                            title:
                                                                doc.document_type,
                                                            extension:
                                                                doc.file_extension,
                                                        }
                                                    )
                                                }
                                            >
                                                {isImage ? (
                                                    <Image
                                                        src={`${BASE_URL}/${doc.file_path}`}
                                                        h="180px"
                                                        w="100%"
                                                        objectFit="cover"
                                                    />
                                                ) : (
                                                    <Flex
                                                        h="180px"
                                                        justify="center"
                                                        align="center"
                                                        bg="gray.50"
                                                    >
                                                        <Image
                                                            src={PdfIcon}
                                                            h="80%"
                                                            w="80%"
                                                        />
                                                    </Flex>
                                                )}

                                                <Box p={3}>
                                                    <Text
                                                        fontWeight="600"
                                                        fontSize="12px"
                                                    >
                                                        {
                                                            doc.document_type
                                                        }
                                                    </Text>

                                                    <Text
                                                        fontSize="11px"
                                                        color="gray.500"
                                                    >
                                                        {doc.file_path
                                                            ?.split(
                                                                "/"
                                                            )
                                                            .pop()}
                                                    </Text>
                                                </Box>
                                            </Box>
                                        );
                                    }
                                )}
                            </SimpleGrid>
                        </>
                    )}
                </Box>
            </AppDrawer>

          <Dialog.Root
    open={
        !!selectedMedia
    }
    onOpenChange={(
        details
    ) => {
        if (
            !details.open
        ) {
            setSelectedMedia(
                null
            );
        }
    }}
>
    <Dialog.Backdrop />

    <Dialog.Positioner
        p={{
            base: 4,
            md: 6,
        }}
    >
        <Dialog.Content
            w="100%"
            maxW={{
                base: "95vw",
                md: "700px",
            }}
            maxH="90vh"
            overflow="hidden"
            borderRadius={{
                base: "16px",
                md: "24px",
            }}
        >
            <Dialog.Header>
                <Dialog.Title
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                >
                    {
                        selectedMedia?.title
                    }
                </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body
                p={0}
                overflow="hidden"
            >
                {[
                    "png",
                    "jpg",
                    "jpeg",
                    "webp",
                ].includes(
                    selectedMedia?.extension?.toLowerCase()
                ) ? (
                    <Image
                        src={
                            selectedMedia?.src
                        }
                        w="100%"
                        maxH={{
                            base: "70vh",
                            md: "80vh",
                        }}
                        objectFit="contain"
                    />
                ) : (
                    <Box
                        h={{
                            base: "70vh",
                            md: "80vh",
                        }}
                    >
                        <iframe
                            src={
                                selectedMedia?.src
                            }
                            title={
                                selectedMedia?.title
                            }
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                            }}
                        />
                    </Box>
                )}
            </Dialog.Body>
        </Dialog.Content>
    </Dialog.Positioner>
</Dialog.Root>
        </>
    );
};

export default ViewVehicleDrawer;